export const PERMISSIONS = {
  ORG_ADMIN: {
    ALL: "org-admin:all",
  },
};
